module.exports = __webpack_public_path__ + "img/uniform-martial-arts.fb36b3d3.svg";